import { useStoreQuery } from '../db/context';

/** Id of the hidden "Sjablonen" folder (general templates live in it), if any. */
export function useTemplatesFolderId(): string | null {
  return useStoreQuery((s) => s.getSetting('templates_parent_id'), [], ['settings']) ?? null;
}
